import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default async function callLoginApi(username, password, component) {
  const resp = await fetch(`${API_URL}rest/V1/rider/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept },
    body: JSON.stringify({
      login_post: {
        username: username,
        password: password,
        // store_id: Store_id,
        type: "login",
        // deviceName:navigator.platform
      },
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (result) {
      console.log("logresres", result[0].data);
      if (result[0] && result[0].data && result[0].data.IsLoggedIn == 1) {
        let action = parseInt(result[0].data.IsLoggedIn, 10);
        action = action ? 1 : 0;
        let mark = action ? "Mark In" : "Mark Out";
        localStorage.setItem("mark", JSON.stringify({ mark, action }));
        localStorage.setItem("user", result[0].data.username);
        localStorage.setItem("rider_id", result[0].data.rider_id);
        localStorage.setItem("vehicle_id", result[0].data.rider_id);
        localStorage.setItem("token", result[0].data.tocken);
        localStorage.setItem("secureKey",result[0].data.secureKey)
        component.props.loginAction(false);
      } else notify.show("Login Failed", "error");

      return result;
    });
  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/callLoginApi.js